import { getListDataFunctionFactory } from '../../../modules/getListDataFunctionFactory'
import { getSubindustryListDataByIndustryId } from '../subindustries/mockData'
import type { IIndustry, IIndustryOverview } from '~/types/industry/models'
import type { TEntityId } from '~/types/models'

const industryListData = undefined as unknown as IIndustry[]

export const getIndustryListData = getListDataFunctionFactory<IIndustry[]>({
  listData: industryListData,
  storageKey: 'industries',
  getStartingListData: getStartingIndustryListData,
})

export function _getIDataById(id: TEntityId, list: IIndustry[]): IIndustry {
  if (!list) {
    throw new Error(`_getIDataById called with undefined/null list`)
  }
  const industry = list.find((p: IIndustry) => p.id === id)
  if (!industry) {
    throw new Error(`Can't find industry '${id}'`)
  }
  return industry
}

export async function getIndustryDataById(id: TEntityId): Promise<IIndustry> {
  const list: IIndustry[] = await getIndustryListData()
  if (!list) {
    throw new Error(`getIndustryListData returned undefined/null`)
  }
  return _getIDataById(id, list)
}

export async function getIndustryOverviewData(
  id: string
): Promise<IIndustryOverview | undefined> {
  const list = await getIndustryListData()
  const industryData = await list.find(
    (industry: IIndustry) => industry.id === id
  )
  if (!industryData) {
    return undefined
  }
  const subindustriesData = (await getSubindustryListDataByIndustryId(id)) || []
  const overviewData = {
    industry: industryData,
    subindustries: subindustriesData,
  }
  console.debug(overviewData)
  return overviewData
}

export async function getStartingIndustryListData(): Promise<IIndustry[]> {
  return [
    {
      id: 'XXI0001',
      hrid: 'I0001',
      descr: 'Finance',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXI0002',
      hrid: 'I0002',
      descr: 'Healthcare',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXI0003',
      hrid: 'I0003',
      descr: 'Insurance',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXI0004',
      hrid: 'I0004',
      descr: 'Legal',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXI0005',
      hrid: 'I0005',
      descr: 'Manufacturing',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXI0006',
      hrid: 'I0006',
      descr: 'Restaurant',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXI0007',
      hrid: 'I0007',
      descr: 'Service',
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXI0008',
      hrid: 'I0008',
      descr: 'IT',
      version: '1',
      canBeDeleted: true,
    },
  ]
}
